module.exports = __webpack_public_path__ + "static/img/9.c9b05f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/sp/9.png
// module id = qoFY
// module chunks = 0